import './style.scss';

interface ISpinner {
	size?: number;
}

export const Spinner = ({ size = 20 }: ISpinner) => (
	<div className="donut-spinner" style={{ width: size, height: size }} />
);
